module.exports = __webpack_public_path__ + "img/partner-3.27b35f32.png";